import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { pbapiGetMetadataResponse } from '../../../gen/syncui';

@Injectable({
  providedIn: 'root'
})
export class MetadataStoreService {
  private metadataSubject = new BehaviorSubject<pbapiGetMetadataResponse | null>(null);
  public metadata$ = this.metadataSubject.asObservable();

  /**
   * Stores the metadata response in memory
   */
  setMetadata(metadata: pbapiGetMetadataResponse): void {
    this.metadataSubject.next(metadata);
  }

  /**
   * Gets the current metadata value synchronously
   */
  getMetadata(): pbapiGetMetadataResponse | null {
    return this.metadataSubject.value;
  }

  /**
   * Clears the stored metadata
   */
  clearMetadata(): void {
    this.metadataSubject.next(null);
  }
}
